export default __webpack_public_path__ + "static/media/a6.fd72db38.svg";